import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: () => import('@/views/Index.vue'),
    children: [
      // {
      //   path: '',
      //   redirect:"/filing"
      // },
      {
        path: '/',
        component: () => import('@/views/home/Home.vue'),
        beforeEnter: (to, from, next) => {// 在路由进入前执行的守卫
          window.utils.clearCache(next);// 清除缓存
        }
      },
      {
        path: '/message',
        component: () => import('@/views/message/Message.vue'),
      },
      {
        path: '/active/awardsAct',
        component: () => import('@/views/active/Active.vue'),
        children: [
          {
            path: '',
            redirect: './registration',
          },
          {
            path: 'registration',
            name: 'registration',
            component: () => import('@/views/active/awardsAct/Registration.vue'),
          },
          {
            path: 'publicity',
            name: 'publicity',
            component: () => import('@/views/active/awardsAct/Publicity.vue'),
          },
          {
            path: 'selection',
            name: 'selection',
            component: () => import('@/views/active/awardsAct/Selection.vue'),
          },
        ]
      },
      {
        path: '/active2/awardsAct',
        component: () => import('@/views/active2/Active.vue'),
        children: [
          {
            path: '',
            redirect: './registrationTwo',
          },
          {
            path: 'registrationTwo',
            name: 'registrationTwo',
            component: () => import('@/views/active2/awardsAct/Registration.vue'),
          },
          {
            path: 'publicityTwo',
            name: 'publicityTwo',
            component: () => import('@/views/active2/awardsAct/Publicity.vue'),
          },
          {
            path: 'selectionTwo',
            name: 'selectionTwo',
            component: () => import('@/views/active2/awardsAct/Selection.vue'),
          },
        ]
      },
      {
        path: '/active/developersConference',
        component: () => import('@/views/developersConference/Index.vue'),
      },
      {
        path: '/active/developersConference/preview',
        component: () => import('@/views/developersConference/Preview.vue'),
      },
      // {
      //   path: '/active/awardsAct4',
      //   component: () => import('@/views/active4/AwardsAct.vue'),
      // },
      {
        path: '/active/awardsAct4/member',
        component: () => import('@/views/active4/AwardsActMember.vue'),
      },
      {
        path: '/active/awardsAct4',
        component: () => import('@/views/active4/AwardsAct.vue'),
      },
      {
        path: '/active/awardsAct4/member',
        component: () => import('@/views/active4/AwardsActMember.vue'),
      },
      {
        path: '/filing/demo',
        name: '/filing/demo',
        component: () => import('@/views/filing/demo/Index.vue'),
      },
      {
        path: '/filing/start',
        name: '/filing/start',
        component: () => import('@/views/filing/Start.vue'),
        beforeEnter: (to, from, next) => {// 在路由进入前执行的守卫
          window.utils.clearCache(next);// 清除缓存
        }
      },
      {
        path: '/filing/process',
        component: () => import('@/views/filing/filingMainProcess/Index.vue'),
        children: [
          {
            path: '',
            redirect: "/filing/process/organizer/zjhm"
          },
          {
            path: 'organizer/zjhm',
            name: 'organizer/zjhm',
            component: () => import('@/views/filing/filingMainProcess/organizer/Zjhm.vue'),
            meta: {
              keepAlive: true,
            },
          },
          {
            path: 'organizer/fzrXm1',
            name: 'organizer/fzrXm1',
            component: () => import('@/views/filing/filingMainProcess/organizer/FzrXm1.vue'),
            meta: {
              keepAlive: true,
            },
          },
          {
            path: 'organizer/fzrXm2',
            name: 'organizer/fzrXm2',
            component: () => import('@/views/filing/filingMainProcess/organizer/FzrXm2.vue'),
            meta: {
              keepAlive: true,
            },
          },
          {
            path: 'quickApp/fzrXm1',
            name: 'quickApp/fzrXm1',
            component: () => import('@/views/filing/filingMainProcess/quickApp/FzrXm1.vue'),
            meta: {
              keepAlive: true,
            },
          },
          {
            path: 'quickApp/fzrXm2',
            name: 'quickApp/fzrXm2',
            component: () => import('@/views/filing/filingMainProcess/quickApp/FzrXm2.vue'),
            meta: {
              keepAlive: true,
            },
          },
          {
            path: 'quickApp/faceliveness',
            name: 'quickApp/faceliveness',
            component: () => import('@/views/filing/filingMainProcess/quickApp/Faceliveness.vue'),
          },

          {
            path: 'quickApp/facelivenessPass',
            name: 'quickApp/facelivenessPass',
            component: () => import('@/views/filing/filingMainProcess/quickApp/FacelivenessPass.vue'),
          },
          {
            path: 'quickApp/facelivenessNoPass',
            name: 'quickApp/facelivenessNoPass',
            component: () => import('@/views/filing/filingMainProcess/quickApp/FacelivenessNoPass.vue'),
          },
          {
            path: 'quickApp/photo',
            name: 'quickApp/photo',
            component: () => import('@/views/filing/filingMainProcess/quickApp/Photo.vue'),
          },
          {
            path: 'quickApp/photoMembers',
            name: 'quickApp/photoMembers',
            component: () => import('@/views/filing/filingMainProcess/quickApp/PhotoMembers.vue'),
          },
          {
            path: 'result/info',
            name: 'result/info',
            component: () => import('@/views/filing/filingMainProcess/result/Info.vue'),
          },
          {
            path: 'result/note',
            name: 'result/note',
            component: () => import('@/views/filing/filingMainProcess/result/Note.vue'),
          },
        ]
      },
      {
        path: '/filing/ok',
        name: '/filing/ok',
        component: () => import('@/views/filing/Ok.vue'),
      },
      {
        path: '/document/faq',
        meta: {name: '核准常见FAQ'},
        component: () => import('@/views/document/faq.vue'),
      },
      {
        path: '/document/filing-prepare',
        meta: {name: '核准材料准备'},
        component: () => import('@/views/document/filing-prepare.vue'),
      },
      {
        path: '/commonGameProblem',
        component: () => import('@/views/commonGameProblem/Index.vue'),
        children: [
          { path: '', redirect: 'hot' },
          { path: 'hot', component: () => import('@/views/commonGameProblem/hot/Index.vue') },
          { path: 'faq/:id', component: () => import('@/views/commonGameProblem/faq/Id.vue') },
          { path: 'faqInfo', component: () => import('@/views/commonGameProblem/faqInfo/Index.vue') },
          { path: 'search', component: () => import('@/views/commonGameProblem/search/Index.vue') },
        ]
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({x: 0, y: 1});
      }, 0);
    });
  },
});
router.beforeEach((to, from, next) => {
  next();
});
export default router
